import { ProductPackageAvailability } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const productPackageAvailabilityMessages = defineMessages({
  addon: {
    defaultMessage: 'Add-on',
    description: 'product package availability',
  },
  initial: {
    defaultMessage: 'Initial',
    description: 'product package availability',
  },
})

export function translateProductPackageAvailability(
  intl: IntlShape,
  availability: ProductPackageAvailability,
): string {
  switch (availability) {
    case ProductPackageAvailability.ADDON:
      return intl.formatMessage(productPackageAvailabilityMessages.addon)
    case ProductPackageAvailability.INITIAL:
      return intl.formatMessage(productPackageAvailabilityMessages.initial)
  }
}
